<div *ngIf="missingMandatoryParameters">
  <h3>{{ 'SHARED.SORRY' | translate }}</h3>
  <h3>{{ 'CHECKOUT.SAP_MISSING_PARAMETERS' | translate }}</h3>
  <h3>
    {{ 'SHARED.TRY_AGAIN' | translate }}
  </h3>
  <h3>{{ 'AUTH.ERROR_CONTACT' | translate }} {{ 'SHARED.CUSTOMER_SERVICE' | translate }}</h3>
</div>
